import React, {useEffect, useState, Fragment} from 'react';
import CUFormService from "../../../../services/CUFormService";
import {CHECK_IMG} from "../../../../constants";
import Color from "color";
import FormService from "../../../../services/FormsService";


const TemplateCUTaxeDemo = (props) => {

    const cuFormService = new CUFormService();
    const formService = new FormService();
    const [annexes, setAnnexes] = useState();

    useEffect(()=>{
        setAnnexes(formService.getEntityAnnexes())
    }, [])

    useEffect(()=>{

    },[annexes])


    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>ARTICLE 5 - Taxes</h3>
            </div>
                <p>
                    Les taxes suivantes pourront être exigées à compter de l'obtention d'un permis ou d'une décision de non opposition à une déclaration préalable :
                </p>
                <table className={'ue-form-table-row'} >
                    <thead>
                    <tr className={"ue-table-row-header"}>
                        <th style={{"width":"43px"}} className={'text-left'}>Catégorie</th>
                        <th className={'text-center'}>Description</th>
                        <th width={'10%'} className={'text-center'}>Taux</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>TA</td>
                            <td>Part de la taxe d’aménagement</td>
                            <td className={'text-right'}>
                                {
                                    (annexes?.a5_ta && annexes?.a5_ta > 0)
                                    ? <span>{annexes?.a5_ta}</span>
                                    :'5.0'
                                }%

                            </td>
                        </tr>
                        <tr>
                            <td>TD</td>
                            <td>Part de la taxe départementale</td>
                            <td className={'text-right'}>
                                {
                                    (annexes?.a5_td && annexes?.a5_td > 0)
                                        ? <span>{annexes?.a5_td}</span>
                                        :'2.4'
                                }%

                            </td>
                        </tr>
                        <tr>
                            <td>RAP</td>
                            <td>Part de redevance archéologique</td>
                            <td className={'text-right'}>
                                {
                                    (annexes?.a5_rap && annexes?.a5_rap > 0)
                                        ? <span>{annexes?.a5_rap}</span>
                                        :'0.4'
                                }%

                            </td>
                        </tr>

                    </tbody>
                </table>
            <br/>
            <br/>
       </div>
    );
};

export default TemplateCUTaxeDemo;
